import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    font-family: 'Montserrat', sans-serif;
    background-color: white;
    color: #1F1A40;
    -webkit-font-smoothing: antialiased;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  input, textarea, select {
    font-family: inherit;
    background: none;
    border: none;
    outline: none;
    color: #1F1A40;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ::selection {
    background: #3A79ED;
    color: white;
  }
`;

export default GlobalStyle;